/**
 * packages/common/src/utils/index.js
 * 通用工具函数
 */

//从浏览器地址栏中读取参数
export function getObjFromUrl(url) {
  function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  var args = url.split("?");
  if (args[0] == url) {
    return "";
  }
  var arr = args[1].split(/&(?!amp;)/).filter((item) => item !== "");
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    var arg = arr[i].split("=");
    var val = arg[1] ? arg[1].replace(new RegExp("&amp;", "g"), "&") : arg[1];
    if (isJsonString(val)) {
      var parsed = JSON.parse(val);
      // 查询字符串中的 "true"/"false" 保持为字符串，避免后端收到 bool 导致兼容问题（如 csv 参数需为字符串 'true'）
      if (typeof parsed === 'boolean') {
        obj[arg[0]] = val;
      } else {
        obj[arg[0]] = parsed;
      }
    } else {
      obj[arg[0]] = val;
    }
  }
  return obj;
}

/**
 * 设置 Y 轴最大值
 * @param {Array} arrayF - 数据数组
 * @returns {Number} 计算后的最大值
 */
export function setYAxisMaxVal(arrayF) {
  let flatten = (arr) => {
    while (arr.some((item) => Array.isArray(item))) {
      arr = [].concat(...arr);
    }
    return arr;
  };
  let returnMaxValue = (array, referMax) => {
    try {
      if (Math.max(...array.flat(Infinity)) > referMax) {
        referMax =
          referMax -
          (Math.max(...array.flat(Infinity)) % referMax) +
          Math.max(...array.flat(Infinity));
      }
      return referMax;
    } catch (error) {
      if (Math.max(...flatten(array)) > referMax) {
        referMax =
          referMax -
          (Math.max(...flatten(array)) % referMax) +
          Math.max(...flatten(array));
      }
      return referMax;
    }
  };
  let maxValue = 10;
  maxValue = returnMaxValue(arrayF, maxValue);
  var big_val = maxValue
    ? formatInt(maxValue, (Math.round(maxValue) + "").length - 2)
    : 100;
  return big_val;
}

/**
 * 设置 Y 轴最小值
 * @param {Object|Array} obj - 数据对象或数组
 * @param {Boolean} isArr - 是否为数组格式
 * @returns {Number} 计算后的最小值
 */
export function setYAxisMinVal(obj, isArr = false) {
  let small_val = 0;
  if (isArr) {
    small_val = 100000000;
    obj.forEach((item) => {
      if (item < small_val) {
        small_val = item;
      }
    });
  } else {
    small_val = 0;
    Object.keys(obj).forEach((item) => {
      obj[item].forEach((ele) => {
        if (ele * 100 < small_val) {
          small_val = ele * 100;
        }
      });
    });
  }
  return Math.floor(small_val);
}

/**
 * 设置 Y 轴最大值（用于 yoy/qoq 数据）
 * @param {Object} obj - 数据对象
 * @returns {Number} 计算后的最大值
 */
export function setYAxisMaxVal_1(obj) {
  let small_val = 0;
  small_val = 0;
  Object.keys(obj).forEach((item) => {
    if (item.indexOf("yoy") > -1 || item.indexOf("qoq") > -1) {
      obj[item].forEach((ele) => {
        if (ele * 100 > small_val) {
          small_val = ele * 100;
        }
      });
    }
  });

  return Math.ceil(small_val);
}

/**
 * 数字转百分比，保留小数点后3位（不四舍五入）
 * @param {Number} data - 要转换的数字
 * @returns {String} 百分比字符串
 */
export function threeDigitsPercentage(data) {
  //数字转百分比保留小数点后3位不会4舍5入
  if (data == "-") {
    return data;
  }
  let data1 = Math.floor(data * 10000) / 100 + "%";
  return data1;
}

/**
 * 格式化整数（向上或向下取整到指定精度）
 * @param {Number} num - 要格式化的数字
 * @param {Number} prec - 精度（默认2）
 * @param {Boolean} ceil - 是否向上取整（默认true）
 * @returns {Number} 格式化后的数字
 */
export function formatInt(num, prec = 2, ceil = true) {
  const len = String(num).length;
  if (len <= prec) {
    return num;
  }

  const mult = Math.pow(10, prec);
  return ceil ? Math.ceil(num / mult) * mult : Math.floor(num / mult) * mult;
}

/**
 * 设置柱状图 Y 轴最大值
 * @param {Array} array - 数据数组
 * @param {Boolean} isPercent - 是否为百分比（默认false）
 * @returns {Number} 计算后的最大值
 */
export function setBarMaxVal(array, isPercent = false) {
  const arr = array.filter((item) => item != "-");
  const max = Math.max(...arr);
  let result = "";
  let stringMax = parseInt(max).toString();
  let num = 5;
  if (stringMax.length > 2) {
    num = Math.pow(10, stringMax.length - 2) * 5;
  }
  if (!isPercent) {
    result = Math.ceil(max / num) * num;
  } else {
    result = Math.ceil((max * 100) / num) * num;
  }
  if (result < 0) {
    return 0;
  } else {
    return result;
  }
}

/**
 * 设置柱状图 Y 轴最小值
 * @param {Array} array - 数据数组
 * @param {Boolean} isPercent - 是否为百分比（默认false）
 * @returns {Number} 计算后的最小值
 */
export function setBarMinVal(array, isPercent = false) {
  const arr = array.filter((item) => item != "-");
  const min = Math.min(...arr);
  let result = "";
  let stringMin = parseInt(min).toString();
  let num = 5;
  if (stringMin.length > 2) {
    num = Math.pow(10, stringMin.length - 2) * 5;
  }
  if (!isPercent) {
    result = Math.floor(min / num) * num;
  } else {
    result = Math.floor((min * 100) / num) * num;
  }
  if (result > 0) {
    return 0;
  } else {
    return result;
  }
}
export function plat_region(plat) {
  var region_domain_map = {
    vn: "vn",
    th: "co.th",
    sg: "sg",
    ph: "com.ph",
    my: "com.my",
    id: "co.id",
  };
  var p = {};
  if (plat.indexOf("amazon") >= 0) {
    p.plat = "amazon";
    if (plat == "amazon_jp") {
      p.region = "co.jp";
    } else if (plat == "amazon" || plat == "amazon_us") {
      p.region = "com";
    } else if (plat == "amazon_uk") {
      p.region = "co.uk";
    } else {
      try {
        p.region = plat.split("_")[1];
      } catch (err) {
        p.region = "com";
      }
    }
  } else if (plat.indexOf("shopee") >= 0) {
    p.plat = "shopee";
    if (plat == "shopee_tw") {
      p.region = "xiapi";
    } else {
      try {
        p.region = plat.split("_")[1];
      } catch (err) {
        p.region = "xiapi";
      }
    }
  } else if (plat.indexOf("lazada") >= 0) {
    p.plat = "lazada";
    try {
      var r = plat.split("_")[1];
      p.region = region_domain_map[r];
    } catch (err) {
      p.region = "";
    }
  } else if (plat.indexOf("tiktok") >= 0) {
    p.plat = "tiktok";
    try {
      let r = plat.split("_")[1];
      p.region = r.toUpperCase();
    } catch (err) {
      p.region = "";
    }
  } else {
    p.plat = plat;
    p.region = "";
  }
  return p;
}

export function setUrlParams(Url, params, val) {
  if (!Url.split("?")[1]) {
    return Url + "?" + params + "=" + val;
  }
  var urlParams = Url.split("?")[1];
  var urlArr = urlParams.split("&");
  let str = "";
  if (urlParams.indexOf(params) < 0) {
    return Url + "&" + params + "=" + val;
  } else {
    for (var i = 0; i < urlArr.length; i++) {
      var urlArrItem = urlArr[i].split("=");
      if (urlArrItem[0] == params) {
        str = urlArrItem[0] + "=" + urlArrItem[1];
        return Url.replace(str, params + "=" + val);
      }
    }
  }
}
export function transformNum(val) {
  if (val == null) return "";
  return val.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}
